module.exports = __webpack_public_path__ + "Roboto-Bold.c8bcb1cb78f9e45e2bcb.eot";


//////////////////
// WEBPACK FOOTER
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/~/roboto-fontface/fonts/Roboto/Roboto-Bold.eot
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-Bold.eot
// module chunks = 5